import DealFormFields from './DealFormFields';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Plus } from '../../../../shared/assets/AppIcons';

import { useDealForm } from '../hooks/useDealForm';
import { buildNewClientLocation } from '../utils';

import { CreateFormCancelButton, CreateFormDialog, CreateFormSubmitButton } from '../../../../shared/components/CreateFormDialog';
import '../../styles/deal-create-form.css';

export default function BaseDealFormDialog({
  isOpen, onClose, onCreate, dealType = 'inCorso', stages = [], staff = [], staffCatalogStatus = 'empty', clients = [],
}) {
  const navigate = useNavigate();
  const isStaffSelectionDisabled = staff.length === 0;
  const {
    meta, formState, isSubmitting, updateField, handleClientSelect,
    addScadenza, updateScadenza, updateInstallmentAmount, beginInstallmentAmountEdit,
    commitInstallmentAmount, installmentDrafts, removeScadenza, handleSubmit, handleClose,
  } = useDealForm({
    dealType, stages, clients, onClose, onCreate, isOpen,
    onRequestNewClient: () => { onClose(); navigate(buildNewClientLocation()); },
  });

  return <CreateFormDialog busy={isSubmitting} open={isOpen} onOpenChange={handleClose}
    icon={Plus} title={meta.title} className="deal-create-dialog"
    footer={<>
      <CreateFormCancelButton onClick={handleClose} disabled={isSubmitting} />
      <CreateFormSubmitButton saving={isSubmitting} form="deal-form" disabled={isStaffSelectionDisabled}>
        {meta.submitLabel}
      </CreateFormSubmitButton>
    </>}
  >
    <form id="deal-form" className="deal-create-form" onSubmit={(event) => { event.preventDefault(); handleSubmit(); }}>
      <DealFormFields dealType={dealType} formState={formState} staff={staff} clients={clients}
        staffCatalogStatus={staffCatalogStatus} isSubmitting={isSubmitting} updateField={updateField}
        handleClientSelect={handleClientSelect} onRequestNewClient={() => handleClientSelect('nuovo')}
        {...{ addScadenza, updateScadenza, updateInstallmentAmount, beginInstallmentAmountEdit,
          commitInstallmentAmount, installmentDrafts, removeScadenza }} />
    </form>
  </CreateFormDialog>;
}
